export interface GalleryItem {
  id: number;
  title: string;
  destination: string;
  category: string;
  image: string;
}

export const galleryItems: GalleryItem[] = [
  {
    id: 1,
    title: "Bali Rice Terraces",
    destination: "Bali, Indonesia",
    category: "Southeast Asia",
    image: "https://public.readdy.ai/ai/img_res/6ec885e11d88955f6b5912f61c75b938.jpg",
  },
  {
    id: 2,
    title: "Fuji at Dawn",
    destination: "Japan",
    category: "East Asia",
    image: "https://readdy.ai/api/search-image?query=Mount%20Fuji%20Japan%20at%20golden%20sunrise%20reflected%20in%20lake%20with%20cherry%20blossom%20trees%20in%20foreground%2C%20pink%20flowers%2C%20misty%20morning%20atmosphere%2C%20stunning%20travel%20photography&width=600&height=400&seq=3002&orientation=landscape",
  },
  {
    id: 3,
    title: "Cappadocia Balloons",
    destination: "Turkey",
    category: "Middle East",
    image: "https://readdy.ai/api/search-image?query=Cappadocia%20Turkey%20dozens%20of%20colorful%20hot%20air%20balloons%20floating%20over%20fairy%20chimneys%20rocky%20landscape%20at%20sunrise%2C%20orange%20pink%20sky%2C%20magical%20travel%20destination&width=600&height=700&seq=3003&orientation=portrait",
  },
  {
    id: 4,
    title: "Maldives Infinity Pool",
    destination: "Maldives",
    category: "Indian Ocean",
    image: "https://readdy.ai/api/search-image?query=Maldives%20luxury%20overwater%20bungalow%20infinity%20pool%20merging%20with%20turquoise%20ocean%20horizon%2C%20white%20hammock%20tropical%20paradise%2C%20bright%20sunny%20day%20clear%20water&width=600&height=400&seq=3004&orientation=landscape",
  },
  {
    id: 5,
    title: "Eiffel Tower Evening",
    destination: "Paris, France",
    category: "Europe",
    image: "https://readdy.ai/api/search-image?query=Eiffel%20Tower%20Paris%20at%20dusk%20glowing%20golden%20lights%20with%20purple%20pink%20sunset%20sky%2C%20romantic%20city%20atmosphere%2C%20elegant%20iconic%20landmark%20beautiful%20European%20cityscape&width=600&height=700&seq=3005&orientation=portrait",
  },
  {
    id: 6,
    title: "Korean Palace Gardens",
    destination: "Seoul, Korea",
    category: "East Asia",
    image: "https://readdy.ai/api/search-image?query=Changdeokgung%20Palace%20Seoul%20Korea%20beautiful%20traditional%20Korean%20garden%20with%20autumn%20red%20orange%20maple%20leaves%2C%20serene%20and%20peaceful%2C%20historical%20architecture%20travel%20photography&width=600&height=400&seq=3006&orientation=landscape",
  },
  {
    id: 7,
    title: "Thailand Long Tail Boats",
    destination: "Phuket, Thailand",
    category: "Southeast Asia",
    image: "https://readdy.ai/api/search-image?query=Phi%20Phi%20Islands%20Thailand%20crystal%20clear%20emerald%20turquoise%20water%20with%20traditional%20long%20tail%20boats%20and%20limestone%20cliff%20karst%20formations%2C%20tropical%20paradise%20beach%20photography&width=600&height=700&seq=3007&orientation=portrait",
  },
  {
    id: 8,
    title: "Giza Pyramids Sunset",
    destination: "Cairo, Egypt",
    category: "Middle East",
    image: "https://readdy.ai/api/search-image?query=Great%20Pyramids%20of%20Giza%20Egypt%20with%20golden%20desert%20dunes%20at%20sunset%2C%20dramatic%20orange%20red%20sky%2C%20ancient%20wonder%20of%20the%20world%2C%20silhouette%20photography&width=600&height=400&seq=3008&orientation=landscape",
  },
  {
    id: 9,
    title: "Swiss Mountain Train",
    destination: "Switzerland",
    category: "Europe",
    image: "https://readdy.ai/api/search-image?query=Swiss%20Alps%20mountain%20railway%20train%20through%20snow-capped%20peaks%20and%20green%20meadows%20with%20wildflowers%2C%20dramatic%20mountain%20scenery%2C%20clear%20blue%20sky%2C%20travel%20photography%20Switzerland&width=600&height=700&seq=3009&orientation=portrait",
  },
  {
    id: 10,
    title: "Bali Temple Sunset",
    destination: "Bali, Indonesia",
    category: "Southeast Asia",
    image: "https://readdy.ai/api/search-image?query=Tanah%20Lot%20temple%20Bali%20Indonesia%20at%20sunset%20silhouetted%20against%20dramatic%20orange%20golden%20sky%20with%20ocean%20waves%20crashing%20on%20rocks%2C%20magical%20atmospheric%20travel%20photo&width=600&height=400&seq=3010&orientation=landscape",
  },
  {
    id: 11,
    title: "Jeju Hallasan Peak",
    destination: "Jeju, Korea",
    category: "East Asia",
    image: "https://readdy.ai/api/search-image?query=Jeju%20Island%20Korea%20Hallasan%20volcanic%20mountain%20peak%20with%20yellow%20canola%20flower%20fields%20and%20clear%20blue%20sky%2C%20beautiful%20natural%20landscape%20spring%20travel%20photography&width=600&height=700&seq=3011&orientation=portrait",
  },
  {
    id: 12,
    title: "Istanbul Blue Mosque",
    destination: "Istanbul, Turkey",
    category: "Middle East",
    image: "https://readdy.ai/api/search-image?query=Istanbul%20Turkey%20Blue%20Mosque%20Sultanahmet%20at%20blue%20hour%20twilight%20with%20illuminated%20minarets%20and%20fountain%20courtyard%2C%20dramatic%20sky%2C%20historical%20Islamic%20architecture%20photography&width=600&height=400&seq=3012&orientation=landscape",
  },
];

export const galleryCategories = ["All", "Southeast Asia", "East Asia", "Europe", "Middle East", "Indian Ocean"];
